import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hw_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('hw_token');
      localStorage.removeItem('hw_user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Auth
export const register = (email, password, firstName, lastName, age) => 
  api.post('/auth/register', { email, password, first_name: firstName, last_name: lastName, age });
export const verifyOTP = (email, otp) => api.post('/auth/verify-otp', { email, otp });
export const resendOTP = (email) => api.post(`/auth/resend-otp?email=${email}`);
export const login = (email, password) => api.post('/auth/login', { email, password });
export const adminLogin = (email, password) => api.post('/auth/admin-login', { email, password });
export const checkEmail = (email) => api.post(`/auth/check-email?email=${email}`);
export const resetPassword = (email, newPassword) => api.post('/auth/reset-password', { email, new_password: newPassword });

// User
export const getMyProfile = () => api.get('/users/me');
export const updateProfile = (data) => api.put('/users/me', data);
export const getUserProfile = (userId) => api.get(`/users/${userId}`);

// Events
export const createEvent = (data) => api.post('/events', data);
export const getEvents = (params) => api.get('/events', { params });
export const getEventFeed = () => api.get('/events/feed');
export const getInterestedEvents = (sort = 'upcoming') => api.get(`/events/interested?sort=${sort}`);
export const getEvent = (eventId) => api.get(`/events/${eventId}`);
export const upvoteEvent = (eventId) => api.post(`/events/${eventId}/upvote`);
export const passEvent = (eventId) => api.post(`/events/${eventId}/pass`);
export const joinEventChat = (eventId) => api.post(`/events/${eventId}/join`);
export const getMyCreatedEvents = () => api.get('/events/my/created');
export const getMyAttendingEvents = () => api.get('/events/my/attending');

// Chats
export const getMyChats = () => api.get('/chats');
export const getChatMessages = (eventId) => api.get(`/chats/${eventId}/messages`);
export const sendMessage = (eventId, text, replyTo) => api.post(`/chats/${eventId}/messages`, { text, reply_to: replyTo });
export const reactToMessage = (eventId, messageId, emoji) => api.post(`/chats/${eventId}/messages/${messageId}/react?emoji=${encodeURIComponent(emoji)}`);
export const pinMessage = (eventId, messageId) => api.post(`/chats/${eventId}/messages/${messageId}/pin`);

// Ratings
export const createRating = (data) => api.post('/ratings', data);
export const getEventRatings = (eventId) => api.get(`/ratings/event/${eventId}`);
export const getUserRatings = (userId) => api.get(`/ratings/user/${userId}`);
export const deleteRating = (ratingId) => api.delete(`/ratings/${ratingId}`);

// Stats
export const getOrganizerStats = () => api.get('/stats/organizer');

// Meta
export const getCategories = () => api.get('/categories');
export const getInterests = () => api.get('/interests');
export const getCampuses = () => api.get('/campuses');

export default api;
